/**
 * Стек слоёв-наложений: поповеры, меню, модалки.
 *
 * Нужен ровно для одного: Esc должен закрывать **верхний** слой, а не все
 * сразу. Поповер справочника внутри модалки — обычная ситуация (§6.3, ревью),
 * и первый Esc там обязан закрыть поповер, оставив модалку (§13, §2.3).
 * Слушатели вешаются на document, поэтому порядок подписки не помогает —
 * решает принадлежность к верхушке стека.
 */

const stack: symbol[] = []

/** Регистрирует слой при открытии. Возвращает его идентификатор. */
export function pushLayer(name: string): symbol {
  const id = Symbol(name)
  stack.push(id)
  return id
}

/** Снимает слой при закрытии. Идемпотентна. */
export function popLayer(id: symbol): void {
  const index = stack.indexOf(id)
  if (index >= 0) stack.splice(index, 1)
}

/** Верхний ли это слой: только он реагирует на Esc и на клик вне. */
export function isTopLayer(id: symbol): boolean {
  return stack.length > 0 && stack[stack.length - 1] === id
}
